import React from 'react'

import {ForwardOverridableRef} from './types'

// каст нужен для переноса дженерика, который по дефолту не поддерживается forwardRef. За исключением этого типы идентичны исходным
export const forwardOverridableRef: ForwardOverridableRef = React.forwardRef as ForwardOverridableRef
